// 接口域名地址
let baseURL = '';
let hostName = '';
if (process.env.NODE_ENV === 'development') {
  baseURL = 'https://cicc.odrnet.cn/pc';
  hostName = 'cicc.odrnet.cn/pc';
} else if (process.env.NODE_ENV === 'production') {
  if (process.env.VUE_APP_TYPE === 'prod') {
    baseURL = 'https://cicc.court.gov.cn/pc';
    hostName = 'cicc.court.gov.cn/pc';
  } else {
    baseURL = 'https://cicc.odrnet.cn/pc';
    hostName = 'cicc.odrnet.cn/pc';
  }
}

export default {
  baseURL,
  hostName
};

